//#region types
import { MonthInputProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import { FormControl } from "@mui/material";
import MonthPicker from "components/common/datePickers/monthPicker";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const MonthInput: React.FC<MonthInputProps> = (props: MonthInputProps) => {
  const onChange = (date?: Date) => {
    props.setValue(date);
  };
  return (
    <FormControl fullWidth className={cssExports.inputFormControl}>
      <MonthPicker
        selected={props.value ?? undefined}
        onChange={onChange}
        error={props.hasError}
        label={LocalizationHelperInstance.getFormattedMessage(props.label)}
        excludeDates={props?.excludeMonths}
        onBlur={props.onBlur}
        disabled={props.disabled}
        popperProps={{ strategy: props?.popperPositionFixed ? "fixed" : "" }}
        minDate={props?.minDate}
        maxDate={props?.maxDate}
        setLastDayOfMonth={props?.setLastDayOfMonth}
        hideClearable={props?.disabled ?? props?.hideClearable}
        popperModifiers={
          props?.popperPositionFixed
            ? [
                {
                  name: "flip",
                  options: {
                    fallbackPlacements: ["left"],
                  },
                },
              ]
            : []
        }
        className={props.className}
        name={props.name}
        data-testid={`${props.name}MonthInput`}
      />
    </FormControl>
  );
};

export default MonthInput;
